import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { IntegrationService } from '../../../services/ajs-integration.service';

@Component({
  selector: 'mandae-integration-setup-credentials',
  templateUrl: './integration-setup-credentials.component.html',
  styleUrls: ['./integration-setup-credentials.component.scss', '../integration-setup-dialog.shared.scss']
})
export class IntegrationSetupCredentialsComponent implements OnInit, OnDestroy {

  @Input() fields: any[] = [];
  @Input() providerSlug = '';
  @Input() stepCount = 0;
  @Input() stepNumber = 0;

  @Output() back = new EventEmitter();
  @Output() next = new EventEmitter();

  public formGroup: FormGroup;

  public constructor(private integrationService: IntegrationService) { }

  private valueChangesSubscription: Subscription = null;

  public ngOnInit(): void {
    this.formGroup = new FormGroup(
      this.fields.reduce((group, field) => {
        group[field.key] = new FormControl('', Validators.required);
        return group;
      }, {})
    );

    this.valueChangesSubscription = this.formGroup.valueChanges.subscribe(() => {
      this.fields.forEach(field => {
        const control = this.formGroup.get(field.key);
        if (control.hasError('authorize')) {
          control.setErrors(null);
        }
      });
    });
  }

  public ngOnDestroy(): void {
    this.valueChangesSubscription.unsubscribe();
  }

  public async handleSubmit(): Promise<void> {
    if (this.formGroup.invalid) {
      return;
    }

    try {
      await this.integrationService.authorize(this.providerSlug, this.formGroup.value);
      this.next.emit();
    } catch (e) {
      this.fields.forEach(field => this.formGroup.get(field.key).setErrors({ authorize: true }));
    }
  }

  public handleClickBack(): void {
    this.back.emit();
  }

}
